const GATEWAY_URL = (process.env.VUE_APP_HYDRO_API_URL || '').replace(/\/$/, '')
const REQUIRE_API = process.env.VUE_APP_HYDRO_REQUIRE_API === 'true'

export function requireKnowledgeApi() {
  return REQUIRE_API
}

async function postKnowledge(path, body) {
  if (GATEWAY_URL === 'local') {
    throw new Error('Knowledge API disabled by VUE_APP_HYDRO_API_URL=local')
  }
  const response = await fetch(`${GATEWAY_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Hydro-Role': 'knowledge_admin', 'X-Hydro-User': 'frontend-knowledge-user' },
    body: JSON.stringify(body || {}),
  })
  if (!response.ok) {
    throw new Error(`${path} responded ${response.status}`)
  }
  return response.json()
}

async function uploadKnowledge(path, formData) {
  if (GATEWAY_URL === 'local') {
    throw new Error('Knowledge API disabled by VUE_APP_HYDRO_API_URL=local')
  }
  const response = await fetch(`${GATEWAY_URL}${path}`, {
    method: 'POST',
    headers: { 'X-Hydro-Role': 'knowledge_admin', 'X-Hydro-User': 'frontend-knowledge-user' },
    body: formData,
  })
  if (!response.ok) {
    let detail = ''
    try {
      const payload = await response.json()
      detail = payload?.detail?.message || payload?.detail?.error_code || ''
    } catch (error) {
      detail = await response.text()
    }
    throw new Error(detail || `${path} responded ${response.status}`)
  }
  return response.json()
}

export function queryKnowledge(question, options = {}) {
  return postKnowledge('/knowledge/query', {
    question,
    top_k: options.top_k || 4,
    domain: options.domain || '',
    context: Array.isArray(options.context) ? options.context : [],
  })
}

export function ingestKnowledgeDocument(payload) {
  return postKnowledge('/knowledge/ingest', payload)
}

export function uploadKnowledgeFile(file, options = {}) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('title', options.title || file.name || '')
  formData.append('chunk_size', String(options.chunk_size || 420))
  formData.append('overlap', String(options.overlap || 60))
  return uploadKnowledge('/knowledge/upload', formData)
}

export function formatKnowledgeAnswer(payload) {
  const citations = Array.isArray(payload.citations) ? payload.citations : []
  const citationText = citations
    .map((item, index) => {
      const title = item.document_title || item.document_id || '未命名资料'
      const quote = item.quote ? `：${item.quote}` : ''
      return `[${index + 1}] ${title} / ${item.chunk_id}${quote}`
    })
    .join('\n')
  return citationText
    ? `${payload.answer}\n\n引用依据：\n${citationText}`
    : payload.answer
}

export function toKnowledgeMessage(payload) {
  return {
    content: formatKnowledgeAnswer(payload),
    citations: Array.isArray(payload.citations) ? payload.citations : [],
    actions: Array.isArray(payload.actions) ? payload.actions : [],
    retrieval: payload.retrieval || {},
  }
}
